import fetchGraphQl from "./fetchGraphQl";
import { useQuery } from "react-query";

const fetchHeatData =
  (userId: string, { startDate, endDate }: any) =>
  async () => {
    const { data = { heat: []}, error } = await fetchGraphQl(
      `
      query queryHeatData {
        heat: heat_daily_view(where: {daily_interval: {_gt: "${startDate.toISOString()}", _lt: "${endDate.toISOString()}"}}, order_by: {daily_interval: asc}) {
          timestamp: daily_interval
          destroyed_energie_mw
          consumed_energie_mw
          chp_energie_mw
          miners_energie_mw
        }
      }
    `,
      "queryHeatData",
      userId
    ) ?? {};

    let total = {
      consumedByFarm: 0,
      heatByCHP: 0,
      heatByMiners: 0,
      destroyed: 0,
    };

    if (!error) {
      data.heat.forEach((item: any) => {
        total.consumedByFarm += item.consumed_energie_mw;
        total.heatByCHP      += item.chp_energie_mw;
        total.heatByMiners   += item.miners_energie_mw;
        total.destroyed      += item.destroyed_energie_mw;
      });
    }

    return { ...data, total };
  };

export const useHeatData = (userId: string, dayRange: any, farmName: string) => {
  return useQuery(["heat", dayRange, farmName], fetchHeatData(userId, dayRange), {
    refetchOnWindowFocus: true,
  });
};
